import { createRootRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/shared/ui';

export const Route = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
